<template>
	<div class="product-inquiry-page">
		<form id="product-inquiry-form" @submit.prevent="modify">
			<ProductController ref="controller" />
		</form>
		<div class="btn-wrap-main">
			<button
				class="btn-main blue bordered"
				type="button"
				v-text="'취소'"
				@click="$refs.controller.refresh()"
			/>
			<button
				form="product-inquiry-form"
				type="submit"
				class="btn-main blue"
				v-text="'수정'"
			/>
		</div>
		<template v-if="showLabel">
			<div
				class="product-inquiry__label--green"
				v-if="savedFactorsLength"
			>
				{{ savedFactorsLength }}개의 성분이 등록되어있습니다.
			</div>
			<div class="product-inquiry__label--red" v-else>
				성분을 등록해주세요.
			</div>
		</template>

		<section data-app>
			<v-dialog v-model="dialog_view_log" scrollable max-width="400">
				<view-log :id="parseInt($route.params.idProduct)" />
			</v-dialog>
		</section>
	</div>
</template>
<script>
	import { mapState } from 'vuex';
	import ProductController from '@/components/product/ProductController.vue';
	import ViewLog from './_view_log.vue';
	import { exportJsonToExcel } from '@/util';

	export default {
		name: 'ProductInquiry',
		components: { ProductController, ViewLog },
		data() {
			return {
				showLabel: false,
				dialog_view_log: false,
				viewExpression: false,
			};
		},
		computed: {
			...mapState({
				IMAGE_STORAGE_PATH: state => state.env.IMAGE_STORAGE_PATH,
				idBrand: state => state.ProductController.idBrand,
				brandTitle: state => state.ProductController.brandTitle,
				savedFactorsLength: state =>
					state.ProductController.savedFactorsLength,
				primarySecondCategoryIdx: state =>
					state.ProductController.primarySecondCategoryIdx,
				releaseDate: state => state.ProductController.releaseDate,
				ImageDTO: state => state.ProductController.ImageDTO,
				productTitle: state => state.ProductController.productTitle,
			}),
		},
		watch: {
			showLabel(nv) {
				if (nv === false) return;
				setTimeout(() => {
					this.showLabel = false;
				}, 5000);
			},
		},
		beforeMount() {
			document.getElementById('admin2').scrollTop = 0;
		},
		async mounted() {
			const idProduct = Number(this.$route.params.idProduct);
			await this.$store.dispatch(
				'ProductController/getProductDetail',
				idProduct
			);
			await this.$store.commit('ProductController/togglePageType', true);

			if (this.idBrand && this.brandTitle) {
				this.$refs.controller.$refs.SearchBrand.setBrandOnlyId(
					Number(this.idBrand)
				);
			}

			await this.$store.dispatch(
				'ProductController/getCommentList',
				idProduct
			);
			this.showLabel = true;
			if (this.ImageDTO.hasOwnProperty('fileSaveName')) {
				this.$refs.controller.$refs.imageUploader.setImageByUrl(
					`${this.IMAGE_STORAGE_PATH}${this.ImageDTO.fileDir}/${this.ImageDTO.fileSaveName}`
				);
			}
		},
		methods: {
			async modify() {
				try {
					const categorySelector =
						this.$refs.controller.$refs.categorySet.$refs
							.categorySelector;
					let categoryMappings = null;
					if (categorySelector && categorySelector.length > 0) {
						categoryMappings = categorySelector.map(
							(component, idx) => {
								const obj = {
									idFirstCategory: component.category1,
									idSecondCategory: component.category2,
									idThirdCategory: component.category3,
								};
								if (idx === this.primarySecondCategoryIdx)
									obj.isPrimary = true;
								return obj;
							}
						);
					}
					const result = await this.$store.dispatch(
						'ProductController/register',
						{ categoryMappings, isRegister: false }
					);
					if (!result) return;
					alert(
						typeof result === 'string'
							? result
							: '제품 수정이 완료되었습니다.'
					);
					if (typeof window.modify === 'function') {
						window.modify();
					}
					this.$router.go(-1);
				} catch (err) {
					console.error(err);
				}
			},

			openViewLogDialog() {
				this.dialog_view_log = true;
			},

			async openViewExpression() {
				try {
					const productId = this.$route.params.idProduct;
					const { data } = await this.$axiosAdmin2.get(
						`/api/dalpha/expression/${productId}`
					);
					this.$store.commit('modal/toggleModal', {
						id: 'ExpressionChange',
						params: { data },
					});
				} catch (error) {
					console.error(error);
					alert(
						'데이터를 가져오는데 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의주세요'
					);
				}
			},

			async analyzeAi() {
				const productId = this.$route.params.idProduct;
				try {
					8;
					const { data } = await this.$axiosAdmin2.get(
						`/api/products/${productId}/dalpha-review-analysis`
					);
					const productKeywordList = data.productKeywordList.map(
						item => {
							return {
								productId: item.productId,
								productTitle: item.productTitle,
								keyword: item.keyword,
								overall: item.overall,
								posReviewCount: item.posReviewCount,
								negReviewCount: item.negReviewCount,
								neuReviewCount: item.neuReviewCount,
							};
						}
					);
					const productExpressionList =
						data.productExpressionList.map(item => {
							return {
								productId: item.productId,
								productTitle: item.productTitle,
								expression: item.expression,
								sentiment: item.sentiment,
								reviewCount: item.reviewCount,
							};
						});
					const sheets = [
						{
							data: productKeywordList,
							name: 'AI 분석 - 키워드 리스트',
							headers: [
								'제품 번호',
								'제품명',
								'키워드',
								'총평',
								'해당총평 긍정리뷰수',
								'해당총평 부정리뷰수',
								'해당총평 중립리뷰수',
							],
						},
						{
							data: productExpressionList,
							name: 'AI 분석 - 표현 리스트',
							headers: [
								'제품 번호',
								'제품명',
								'표현',
								'해당 표현 감정',
								'해당표현 리뷰수',
							],
						},
					];
					exportJsonToExcel(
						sheets,
						`[${productId}] ${this.productTitle} AI 분석 결과`
					);
				} catch (error) {
					console.error(error);
					if (error.response.status === 400) {
						alert(
							`${error.response.data.message || 'AI 분석 결과가 없습니다.'} `
						);
					} else {
						alert('AI 분석 결과를 가져오는데 실패했습니다.');
					}
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.product-inquiry__label--red,
	.product-inquiry__label--green {
		position: fixed;
		bottom: 28px;
		right: 28px;
		padding: 8px;
		background: white;
		border-radius: 4px;
		font-size: 1.25rem;
	}

	.product-inquiry__label--green {
		border: solid 1px $green;
		color: $green;
	}

	.product-inquiry__label--red {
		border: solid 1px $red;
		color: $red;
	}
</style>
